import { useState } from "react";
import PhoneInputField from "../../atoms/phoneInput/PhoneInputField";
import "./Register.css";
import { FRENCH_DEPARTMENTS } from "../../../consts/frenchDepartements";

export default function Register({ onSwitchToLogin, register }) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",

    areaOfInterest: "",
    areaOfInterest2: "",
  });

  const [errors, setErrors] = useState({});
  const [showSecondAoi, setShowSecondAoi] = useState(false);

  const emailRegex = /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: undefined });
    }
  };

  const handlePhoneChange = (value) => {
    setForm({ ...form, phone: value });
    if (errors.phone) {
      setErrors({ ...errors, phone: undefined });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.firstName.trim()) newErrors.firstName = "Le prénom est requis";
    if (!form.lastName.trim()) newErrors.lastName = "Le nom est requis";

    if (!form.email.trim()) {
      newErrors.email = "L'adresse e-mail est requise";
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = "Veuillez entrer une adresse e-mail valide";
    }

    if (!form.confirmEmail.trim()) {
      newErrors.confirmEmail = "Veuillez confirmer votre adresse e-mail";
    } else if (
      form.email.trim() &&
      form.confirmEmail.trim() !== form.email.trim()
    ) {
      newErrors.confirmEmail = "Les adresses e-mail ne correspondent pas";
    }

    if (!form.areaOfInterest.trim()) {
      newErrors.areaOfInterest = "La zone d'intérêt est requise";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const emptyForm = {
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    areaOfInterest: "",
    areaOfInterest2: "",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      first_name: form.firstName,
      last_name: form.lastName,
      email: form.email,
      interested_zones: form.areaOfInterest,
      interested_zones_2: form.areaOfInterest2 || null,
    };

    if (register) {
      await register(
        payload,
        () => {
          setForm(emptyForm);
          setErrors({});
          setShowSecondAoi(false);
        },
        (error) => {
          // Backend 422 — email already taken
          if (error?.detail === "Email already registered") {
            setErrors((prev) => ({
              ...prev,
              email: "Cette adresse e-mail est déjà utilisée",
            }));
          }
        },
      );
    }
  };
  return (
    <div className="register-wrapper">
      <h2>S’inscrire aux notifications</h2>

      <form onSubmit={handleSubmit} className="register-form" noValidate>
        {/* Row 1: First Name & Last Name */}
        <div className="form-row">
          <div className="input-group">
            <input
              type="text"
              name="firstName"
              placeholder="Prénom"
              value={form.firstName}
              onChange={handleChange}
              required
            />
            {errors.firstName && (
              <span className="error-msg">{errors.firstName}</span>
            )}
          </div>
          <div className="input-group">
            <input
              type="text"
              name="lastName"
              placeholder="Nom"
              value={form.lastName}
              onChange={handleChange}
              required
            />
            {errors.lastName && (
              <span className="error-msg">{errors.lastName}</span>
            )}
          </div>
        </div>

        {/* Row 2: Email & Confirm Email */}
        <div className="form-row">
          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder="Adresse e-mail"
              value={form.email}
              onChange={handleChange}
              required
            />
            {errors.email && <span className="error-msg">{errors.email}</span>}
          </div>

          <div className="input-group">
            <input
              type="email"
              name="confirmEmail"
              placeholder="Confirmer l'adresse e-mail"
              value={form.confirmEmail}
              onChange={handleChange}
              onPaste={(e) => e.preventDefault()}
              required
            />
            {errors.confirmEmail && (
              <span className="error-msg">{errors.confirmEmail}</span>
            )}
          </div>
        </div>

        {/* Row 6: AOI */}
        <div className="form-row-full">
          <div className="input-group">
            {/* First AOI — always visible */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <select
                name="areaOfInterest"
                value={form.areaOfInterest}
                onChange={handleChange}
                required
                style={{ flex: 1 }}
              >
                <option value="" disabled>
                  Choisissez votre zone d'intérêt (département)
                </option>
                {FRENCH_DEPARTMENTS.map((dept) => (
                  <option key={dept.code} value={dept.name}>
                    {dept.name}
                  </option>
                ))}
              </select>

              {!showSecondAoi && (
                <button
                  type="button"
                  onClick={() => setShowSecondAoi(true)}
                  className="aoi-add-btn"
                >
                  + Ajouter une 2e zone
                </button>
              )}
            </div>
            {errors.areaOfInterest && (
              <span className="error-msg">{errors.areaOfInterest}</span>
            )}

            {/* Second AOI — toggled */}
            {showSecondAoi && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginTop: "10px",
                }}
              >
                <select
                  name="areaOfInterest2"
                  value={form.areaOfInterest2}
                  onChange={handleChange}
                  style={{ flex: 1 }}
                >
                  <option value="">2e zone d'intérêt (optionnelle)</option>
                  {FRENCH_DEPARTMENTS.map((dept) => (
                    <option key={dept.code} value={dept.name}>
                      {dept.name}
                    </option>
                  ))}
                </select>
                <button
                  type="button"
                  onClick={() => {
                    setShowSecondAoi(false);
                    setForm((f) => ({ ...f, areaOfInterest2: "" }));
                  }}
                  className="aoi-remove-btn"
                  aria-label="Supprimer la 2e zone"
                >
                  ×
                </button>
              </div>
            )}
          </div>
        </div>

        <button type="submit" className="register-submit-btn">
          S'INSCRIRE AUX NOTIFICATIONS
        </button>
          <p className="register-unsubscribe-note">
          Vous pouvez demander votre désinscription de ces notifications par
          e-mail à{" "}
          <a href="mailto:info@ensemblepourlaforet.fr">
            info@ensemblepourlaforet.fr
          </a>
        </p>
      </form>
    </div>
  );
}
